import { PortAlert } from '../hooks/portAlertsService'
import { VesselStay } from '../hooks/useFetchVesselStays'

const EXCLUDED_BERTH_PREFIXES = ['manual', 'algopol']

export function isBerthExcluded(berthId: string): boolean {
  const lower = berthId.toLowerCase()
  return EXCLUDED_BERTH_PREFIXES.some((prefix) => lower.startsWith(prefix))
}

export function formatBerthId(berthId: string): string {
  return berthId.replaceAll(';', ' -')
}

export function formatLocation(pa: { countryUnlocode: string; port: string; terminal: string; berth: string; country_name?: string }): string {
  if (pa.berth) return pa.berth
  if (pa.terminal) return pa.terminal
  if (pa.port) return pa.port
  return pa.country_name || pa.countryUnlocode || '—'
}

export function formatLocationType(pa: { berth: string; terminal: string; port: string; countryUnlocode: string }): string {
  if (pa.berth) return 'Berth'
  if (pa.terminal) return 'Terminal'
  if (pa.port) return 'Port'
  if (pa.countryUnlocode) return 'Country'
  return ''
}

export function findMatchingAlert(stay: VesselStay, alerts: PortAlert[], organizationId: string | undefined): PortAlert | undefined {
  const orgAlerts = alerts.filter(pa => pa.organizationId === organizationId)
  const locode = stay.port_locode + ''

  const berthMatch = orgAlerts.find(
    pa => pa.berth && stay.berth && pa.berth === stay.berth
      && pa.terminal && stay.terminal_name && pa.terminal === stay.terminal_name
  )
  if (berthMatch) return berthMatch

  const terminalMatch = orgAlerts.find(
    pa => pa.terminal && !pa.berth && stay.terminal_name && pa.terminal === stay.terminal_name
      && pa.countryUnlocode && locode.startsWith(pa.countryUnlocode)
  )
  if (terminalMatch) return terminalMatch

  const portMatch = orgAlerts.find(
    pa => pa.port && !pa.terminal && !pa.berth && stay.port && pa.port === stay.port
      && pa.countryUnlocode && locode.startsWith(pa.countryUnlocode)
  )
  if (portMatch) return portMatch

  return orgAlerts.find(
    pa => !pa.port && !pa.terminal && !pa.berth && pa.countryUnlocode && locode.startsWith(pa.countryUnlocode)
  )
}
